<div class="flex mt-2 bg-white p-5 rounded-xl">

  <div *ngIf="isLoading; else loadedVehiclesTemp">{{'labels.loading-data' | translate}}</div>
  <ng-template #loadedVehiclesTemp>

    <div class="flex flex-col mr-6">
      <div id="selected-vehicles-count" class="text-2xl font-bold">{{selectedVehiclesCount}}</div>

      <div class="mt-2 text-sm font-semibold">{{'data-sharing.selected-vehicles' | translate}}</div>

      <div *ngIf="isAnyVehicleSelected && !isViewMode" class="grow flex items-end cursor-pointer mt-6"
           (click)="onRemoveAll()">
        <div class="flex items-center">
          <div class="tk-i-close-blue w-3 h-3 mr-2"></div>
          <div class="tk-c-blue">{{'labels.remove-all' | translate}}</div>
        </div>
      </div>
    </div>

    <div class="tk-border-gray-2 mr-6"></div>

    <span *ngIf="!isAnyVehicleSelected; else selectedVehicles" class="self-center text-xs tk-c-gray-9">
          {{'data-sharing.select-vehicles-on-list' | translate}}
    </span>
    <ng-template #selectedVehicles>
      <div class="grid grid-flow-row-dense grid-cols-3 gap-y-2 h-fit">
        <div *ngFor="let vehicle of displayedFullVehicles" type="button" (click)="onRemoveVehicle(vehicle.Id)"
             class="flex items-center justify-between mr-2 rounded-full bg-transparent hover:font-normal tk-bg-blue-alpha-10 tk-c-blue"
             [ngClass]="{'cursor-pointer': !isViewMode}">
          <span class="mx-4 my-2">{{getVehicleShortName(vehicle.Nm)}}</span>
          <span *ngIf="!isViewMode" class="tk-i-close-blue w-3 h-3 mr-4"></span>
        </div>
        <span *ngIf="isVehiclesLimitExceeded"
              class="flex justify-center items-center w-8 h-8 rounded-full text-center tk-bg-blue text-white ">
            <span>+{{vehiclesAboveLimitCount}}</span>
      </span>
      </div>
    </ng-template>

  </ng-template>
</div>
